/**
 * Admin/studio back-ends for each platform. Shared by the Links page and the
 * ⌘K command palette so there's a single source of truth.
 */
export const adminLinks = [
  { icon: 'youtube', label: 'YouTube Studio', url: 'https://studio.youtube.com' },
  { icon: 'instagram', label: 'Meta Business Suite', url: 'https://business.facebook.com/latest/home' },
  { icon: 'facebook', label: 'Facebook Page manager', url: 'https://business.facebook.com' },
  { icon: 'soundcloud', label: 'SoundCloud uploads', url: 'https://soundcloud.com/you/tracks' },
  { icon: 'bandcamp', label: 'Bandcamp artist tools', url: 'https://bandcamp.com/artists' },
  { icon: 'mixcloud', label: 'Mixcloud upload', url: 'https://www.mixcloud.com/upload/' },
  { icon: 'twitch', label: 'Twitch Creator Dashboard', url: 'https://dashboard.twitch.tv' },
  { icon: 'tumblr', label: 'Tumblr blog settings', url: 'https://www.tumblr.com/settings/blog/djlongbeard' },
  { icon: 'linktree', label: 'Linktree admin', url: 'https://linktr.ee/admin' },
  { icon: 'email', label: 'Brand inbox (Gmail)', url: 'https://mail.google.com' },
];
